import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask3300To3399Service {

  constructor() { }
}
